module.exports = __webpack_public_path__ + "img/reason_06@2x.11b2b0cb.png";